(function () {
  function parseJSON(el){ try { return JSON.parse(el.textContent || "{}"); } catch(e){ return {}; } }

  // Find the REAL product section wrapper (your HTML already has: <div product-info data-section-id="...">)
  function getScope(el){
    return (el.closest('[product-info]') || el.closest('[data-section-id]') || document);
  }

  // Read currently selected options inside the scope (selects, radios, common swatch patterns)
  function readSelectedOptions(scope){
    var selects = Array.from(scope.querySelectorAll('select[name^="options["]'));
    if (selects.length) return selects.map(function(s){ return (s.value || '').trim(); });

    var radios = Array.from(scope.querySelectorAll('input[type="radio"][name^="options["]:checked'));
    if (radios.length) return radios.map(function(r){ return (r.value || '').trim(); });

    var pressed = Array.from(scope.querySelectorAll('[aria-pressed="true"][data-option-value]'));
    if (pressed.length){
      return pressed
        .sort(function(a,b){
          var ai = parseInt(a.getAttribute('data-option-index') || a.dataset.optionIndex || 0,10) || 0;
          var bi = parseInt(b.getAttribute('data-option-index') || b.dataset.optionIndex || 0,10) || 0;
          return ai - bi;
        })
        .map(function(b){ return (b.getAttribute('data-option-value') || '').trim(); });
    }

    // Generic “active” swatch fallback
    var active = Array.from(scope.querySelectorAll('.swatch, .product-option, [data-option]'))
      .map(function(group){
        var a = group.querySelector('.is-active, .active, [aria-selected="true"]');
        return a ? (a.getAttribute('data-option-value') || a.textContent || '').trim() : null;
      }).filter(Boolean);
    if (active.length) return active;

    return [];
  }

  function resolveVariantByOptions(scope){
    var productEl = scope.querySelector('script[data-product-json]');
    var product = productEl ? parseJSON(productEl) : null;
    if (!product || !product.variants) return null;

    var sel = readSelectedOptions(scope);
    if (!sel.length) return null;

    var want = sel.map(function(v){ return String(v||'').trim().toLowerCase(); });
    for (var i=0;i<product.variants.length;i++){
      var v = product.variants[i];
      var opts = (v.options||[]).map(function(o){ return String(o||'').trim().toLowerCase(); });
      if (opts.length === want.length && opts.every(function(o,idx){ return o === want[idx]; })) return v;
    }
    return null;
  }

  function getActiveVariant(scope){
    var v = resolveVariantByOptions(scope);
    if (v) return v;

    // Fallback to hidden/select id if options aren’t readable
    var hidden = scope.querySelector('input[name="id"][type="hidden"]');
    var vid = (hidden && hidden.value) ? hidden.value : null;
    var productEl = scope.querySelector('script[data-product-json]');
    var product = productEl ? parseJSON(productEl) : null;
    if (vid && product && product.variants){
      var match = product.variants.find(function(x){ return String(x.id) === String(vid); });
      if (match) return match;
    }
    return null;
  }

  // ===============================
  // SKU RENDER
  // ===============================
  function renderSkuContainer(container){
    var scope  = getScope(container);
    var target = container.querySelector('[data-sku-target]');
    if (!target) return;

    var mapEl = scope.querySelector('script[data-sku-map]');
    var map   = mapEl ? parseJSON(mapEl) : {};

    var variant = getActiveVariant(scope);
    var sku = variant ? (variant.sku || map[String(variant.id)] || '') : '';

    target.textContent = sku;
    container.style.display = sku ? '' : 'none';
  }

  // ===============================
  // COLOR METAFIELDS RENDER (3 fields)
  // Uses live variant.metafields if available; falls back to a Liquid-provided JSON map:
  // <script type="application/json" data-color-map>{ "VARIANT_ID": { "color_code": "...", "frame_color": "...", "temple_color": "..." } }</script>
  // ===============================
  function renderVariantColors(scope) {
    var variant = getActiveVariant(scope);

    // Optional fallback JSON map
    var cmapEl = scope.querySelector('script[data-color-map]');
    var cmap   = cmapEl ? parseJSON(cmapEl) : {};
    var mapForVariant = variant && cmap ? (cmap[String(variant.id)] || {}) : {};

    // ---- helpers
    function readMF(obj){
      // supports both { value: "..." } and "..." shapes
      if (!obj) return '';
      if (typeof obj === 'object' && 'value' in obj) return obj.value || '';
      return String(obj || '');
    }

    function setLine(el, label, value, spanClass){
      if (!el) return;
      if (value){
        el.innerHTML = '<strong>' + label + ':</strong> <span class="' + spanClass + '">' + value + '</span>';
        el.style.display = '';
      } else {
        el.style.display = 'none';
      }
    }

    // ---- Color Code
    var colorEl = scope.querySelector('[data-color-code]');
    var colorValue = '';
    if (variant && variant.metafields && variant.metafields.custom && variant.metafields.custom.color_code){
      colorValue = readMF(variant.metafields.custom.color_code);
    }
    if (!colorValue) colorValue = readMF(mapForVariant.color_code);
    setLine(colorEl, 'Color Code', colorValue, 'color-value');

    // ---- Frame Color
    var frameEl = scope.querySelector('[data-frame-color]');
    var frameValue = '';
    if (variant && variant.metafields && variant.metafields.custom && variant.metafields.custom.frame_color){
      frameValue = readMF(variant.metafields.custom.frame_color);
    }
    if (!frameValue) frameValue = readMF(mapForVariant.frame_color);
    setLine(frameEl, 'Frame Color', frameValue, 'frame-color-value');

    // ---- Temple Color
    var templeEl = scope.querySelector('[data-temple-color]');
    var templeValue = '';
    if (variant && variant.metafields && variant.metafields.custom && variant.metafields.custom.temple_color){
      templeValue = readMF(variant.metafields.custom.temple_color);
    }
    if (!templeValue) templeValue = readMF(mapForVariant.temple_color);
    setLine(templeEl, 'Temple Color', templeValue, 'temple-color-value');
  }

  // Render everything relevant within a scope
  function renderAllForScope(scope){
    scope.querySelectorAll('[data-sku-container]').forEach(function(c){
      renderSkuContainer(c);
    });
    renderVariantColors(scope);
  }

  function initContainer(container){
    if (container.__sku_init) return;
    container.__sku_init = true;

    var scope = getScope(container);

    // Initial render
    renderSkuContainer(container);
    renderVariantColors(scope);

    // React to UI interactions
    var rerender = function(){ renderSkuContainer(container); renderVariantColors(scope); };
    scope.addEventListener('change', rerender);
    scope.addEventListener('click', function(e){
      if (e.target.closest('[name^="options["], .swatch, [data-option], [data-option-value], .product-option')) {
        setTimeout(rerender, 0);
      }
    });

    // React if the theme swaps DOM
    if ('MutationObserver' in window){
      var mo = new MutationObserver(function(m){
        for (var i=0;i<m.length;i++){
          if ((m[i].addedNodes && m[i].addedNodes.length) || (m[i].removedNodes && m[i].removedNodes.length)){
            setTimeout(rerender, 0);
            break;
          }
        }
      });
      mo.observe(scope, {childList:true, subtree:true});
    }

    // Common theme events
    ['variant:change','variant:changed','product:variant-change','theme:variant:change','shopify:section:load']
      .forEach(function(evt){ document.addEventListener(evt, rerender); });
  }

  function refreshAll(){
    // Ensure all SKU containers are set up
    document.querySelectorAll('[data-sku-container]').forEach(function(c){
      if (!c.__sku_init) initContainer(c);
      renderSkuContainer(c);
    });
    // Also refresh color lines in the full document scope
    renderVariantColors(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refreshAll);
  else refreshAll();
})();
